import React from "react";
import { Accordion, AccordionDetails, Typography, AccordionSummary } from "@material-ui/core";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveIcon from '@material-ui/icons/Remove';
import styled from "styled-components";
import { LinkAnchor } from "@Components/Common/CommonMethods";


const FaqStyle = styled.div`
.refunds-provide{
    font-size: 16px;
}
.faq{
    padding: 200px 0 60px;
    @media (max-width: 991px){
        padding: 180px 0 50px;
    }
    @media (max-width: 767px){
        padding: 140px 0 50px;
    }
    h4 {
    font-family: var(--inte-BD);
    color: var(--green);
    font-size: 32px;
    margin-top: 0;
    margin-bottom: 20px;
    @media (max-width: 767px){
        font-size: 26px;
        margin-bottom: 15px;
    }
}
.wrapper-faq {
    flex-wrap: wrap;
    position: relative;
    left: 0;
    z-index: 9;
    top: 0;
    border: none;
    border-radius: 30px;
    box-shadow: 0 0 20px 7px rgb(0 0 0 / 5%);
    background: #fff;
    padding: 30px; 
    @media (max-width: 767px){
        padding: 20px;
    }
 &>p {
    font-size: 22px;
    color: #000;
    margin-bottom: 20px;
    @media (max-width: 767px){
        font-size: 20px;
        margin-bottom: 15px;
    }
}
}

.MuiAccordionSummary-root p.MuiTypography-root > div {
    font-size: 20px;
    @media (max-width: 767px){
        font-size: 18px;
        line-height: normal;
    }
}

.MuiButtonBase-root.MuiAccordionSummary-root {background: #5fb5be96;
    border-radius: 5px;
    min-height: auto;
    padding:  10px;
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiAccordion-rounded::before {
    display: none;
}

.MuiAccordionSummary-content {
    margin: 0;
}

.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters {
    margin-bottom: 25px;
    box-shadow: none;
}

 
    .MuiAccordion-region .MuiAccordionDetails-root{
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
            ul {
            padding-left: 17px;
            margin-bottom: 10px;
            li {
                font-size: 18px;
                padding-bottom: 5px;
            }
        }
    } 
}
.refunds-provide {
    font-weight: 700 !important;
    font-family: var(--common-fontbd);
}
b, strong {
    font-weight: 700!important;
    font-family: var(--common-fontbd);
}
`;

export default function FaqAccordian(props) {

    return (
        <FaqStyle>
            <>
                <div className="faq">
                    <div className="container">
                        <div className="wrapper-faq">

                            <h4>FAQs SNiP Nutrigenomics</h4>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What is SNiP Nutrigenomics?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>SNiP is the most innovative health and lifestyle company on the planet with science-backed,
                                            proprietary technology to custom compound DNA-based, personalized supplements.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide"> What does SNiP do?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div className="refunds-provide">
                                            Personalized biohacking simplified.

                                            Our products are designed to support individual genetic vulnerabilities impacting overall health and healthspan.<br />
                                            <p>We offer:</p>
                                            <p>11 DNA reports</p>
                                            <p>SNiP reports cover a variety of key health topics. Each one contains simple,
                                                clear information on individual SNPs tested and the SNPs’ relevance for each health topic.
                                                Reports also include:</p>
                                            <ul>
                                                <li>Lifestyle recommendations such as specific types of exercise.</li>
                                                <li>Lab test recommendations your healthcare provider may reference for
                                                    learning more about how your SNPs may be impacting your health and tracking your
                                                    progress on your personalized supplement.</li>
                                                <li>Links for associated studies and additional resources.</li>
                                                <p>CODE Complex™</p>
                                                <p>CODE Complex™ is a revolutionary, foundational nutritional supplement based on your DNA.
                                                    It is custom compounded just for you and delivered to you on a recurring schedule of your choice.

                                                    Based on your personal nutritional needs, as evidenced by the genetic analysis of your cheek swab,
                                                    CODE Complex™ contains vitamins, minerals and micronutrients your body requires for optimal functioning. </p>
                                            </ul>
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Why SNiP Nutritgenomics?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography><p>Science has shown nutrients in the proper form and amount can support your body in maximizing
                                        genetic expression. Cognition, mood, energy, methylation and more are supported when the right nutrition for you is provided.
                                        We analyze your DNA for actionable genetic variations and custom compound your CODE Complex™ based on
                                        the specific SNPs found in your report. The nutrition we provide is selected to help offset
                                        the impact of less-than-optimal SNPs, supporting your health, mood and healthspan in myriad ways.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">
                                            How is SNiP different?
                                        </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>We simplify personalized biohacking.</p>
                                        <p>Genetics and epigenetics are complex concepts-- and even harder to know how to integrate them into tangible
                                            wellness tools. </p>
                                        <p>SNiP tests look for ways to offer proactive recommendations for health and wellness.</p>
                                        <p>SNiP does the research so you don’t have to.</p>
                                        <p>While many DNA tests provide interesting information, most of it isn’t actionable.</p>
                                        <p>SNiP goes beyond raw data.</p>
                                        <p>The heavy-hitting SNPs we report on are scientifically validated as nutritionally actionable.
                                            This means peer-reviewed research has shown that the right types and amounts of particular nutrients can optimize
                                            the expression or functioning of the genes we test for. </p>
                                        <p>So, while some DNA reports can tell you if you are prone to having a unibrow (uh, interesting, we guess?),
                                            no vitamin, mineral or micronutrient can change this unfortunate physical trait.</p>
                                        <p>SNiP, on the other hand, not only tells you exactly which nutrition is needed based on your DNA,
                                            we custom compound your very own, personalized supplement containing the nutrients you need to support your optimal health.
                                            All of this is created for you and delivered to your door monthly, or on a recurring schedule
                                            that works for you.</p>
                                        <p>Every SNiP DNA report also includes lifestyle bio hacks— simple tips and tricks for “hacking” your DNA and
                                            supporting your healthspan, no matter your genetic profile.</p>
                                        <p>SNiP is a revolutionary, all-in-one solution that simplifies supplementation, saves you money,
                                            and ensures your supplement routine is working for you. </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What DNA reports does SNiP offer?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Currently, we offer 11 DNA reports:</p>
                                        <ul>
                                            <li>Healthy BMI</li>
                                            <li>Healthy Heart</li>
                                            <li>Cognitive/Brain Function</li>
                                            <li>Detoxification</li>
                                            <li>Energy</li>
                                            <li>Gut/Microbiome</li>
                                            <li>Healthy Immune Response</li>
                                            <li>Healthy Inflammatory Response</li>
                                            <li>MethylationMethylation</li>
                                            <li>Mood</li>
                                            <li>CODE Complex™ (customized nutritional supplement)</li>
                                        </ul>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How does SNiP work?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Order a DNA test kit through your health provider, employer or directly through us. Once the kit arrives,
                                            swab your cheek and return the sample in the pre-paid envelope.</p>
                                        <p>Once your DNA is analyzed, your DNA reports will become available to you electronically. </p>
                                        <p>At that time, you’ll be provided with the ingredients in your CODE Complex™ supplement and can place your order.
                                            Your formula is made just for, at the time you order; it will take 7-10 business days to receive. </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">When can I order my CODE Complex™?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Because your CODE Complex™ is made just for you, it can’t be made until we know which ingredients your body needs,
                                            based on the results of your DNA report.</p>
                                        <p>After your DNA is analyzed and your report generated, you may place your first order for CODE Complex™; you may
                                            expect to receive your first bottle within 7-10 days.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Where should I start?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Step 1: Order your DNA test kit and reports</p>
                                        <p>Step 2: Once your DNA test kit arrives, follow the included instructions to collect your DNA via cheek swab,
                                            and return your sample in the pre-paid envelope.</p>
                                        <p>Step 3: Once your DNA is analyzed, your reports will be generated electronically. </p>
                                        <p>Step 4: Your report(s) contain your personalized “recipe” for your customized supplement, CODE Complex™.
                                            Once generated, you can go ahead and order your first month, and can expect to receive your CODE
                                            Complex within 7-10 days.</p>
                                        <p>Choose subscribe at checkout and save $20 per month on recurring orders. Shipping on CODE Complex™ is always free.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Do you offer autoship?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Yes! in fact, you'll save $20 on every order of CODE Complex™ by subscribing.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Do you take insurance?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Not at this time. However, if your CODE Complex™ is requested by your physician it may qualify for
                                            payment through an HSA. Check with your physician and HSA for details.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How long has this science been around?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>The scientific research upon which SNiP Nutrigenomics bases its genetic assessment began in 1994. </p>
                                        <p>SNiP Nutrigenomics is committed to exceeding industry’s best practices. Our science team stays current
                                            with peer-review research informing nutritional genomics. Our most recent review of the science upon
                                            which we base our proprietary technology and continue to innovate was conducted in 2022.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How can I share my feedback?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Email support@snipnutrition.com</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <p><strong>Science 101</strong></p>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What is Nutrigenomics?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>NUTRITION + GENETICS = NUTRIGENOMICS</p>
                                        <p><LinkAnchor href="https://www.cancer.gov/publications/dictionaries/cancer-terms/def/nutrigenomics" target="_blank"> Nutrigenomics</LinkAnchor> (or “nutritional genomics”) provides an understanding
                                            of how diet can alter how a person’s <LinkAnchor href="https://www.genome.gov/genetics-glossary/Gene" target="_blank">genes </LinkAnchor>  work,
                                            which in turn can affect health.</p>
                                        <p>The purpose of nutrigenomics is to provide an enhanced, scientific and rational means to optimize
                                            nutrition and absorption of nutrients concerning an individual’s DNA.</p>
                                        <p> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Genetic-Testing" target="_blank"> Genetic testing</LinkAnchor> through a nutrigenomic lens allows us to understand what works and doesn’t work for individuals
                                            given their unique DNA, as well as the biochemical effects on individual capacity for nutrient absorption,
                                            delivery, metabolism, and elimination or biological action.</p>

                                        <p><strong>Genetics Basics</strong></p>
                                        <p>Discover “genetics basics” from the Centers for Disease Control and Prevention (CDC).</p>
                                    </Typography>
                                </AccordionDetails>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">What’s a gene</div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>Find the definition of a gene <LinkAnchor href="https://www.genome.gov/genetics-glossary/Gene" target="_blank"> here.</LinkAnchor></p>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">What’s a protein</div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>Find the definition of a protein <LinkAnchor href="https://www.genome.gov/genetics-glossary/Protein" target="_blank"> here.</LinkAnchor></p>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What’s a SNP (single nucleotide polymorphism)</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Single nucleotide polymorphism, or SNP, is pronounced: “snip." These are common, genetic variants
                                            that alter the functions of genes naturally. Hair, eye color, and skin color are all determined by certain SNPs. </p>
                                        <p>SNiP Nutrigenomics tests for actionable SNPs that have functionally significant effects on genetic expression,
                                            and as a result, can help your body perform essential functions and impact long-term impact health and wellness.
                                            (See the summary of each gene separately in this report).</p>
                                        <p>What are SNPs (Pronounced “Snips”)</p>
                                    </Typography>
                                </AccordionDetails>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">Whats an allele</div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>Find the definition for allele <LinkAnchor href="https://www.genome.gov/genetics-glossary/Allele" target="_blank"> here.</LinkAnchor></p>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">What’s a risk allele</div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>Find the definition  risk allele<LinkAnchor href="https://www.ebi.ac.uk/training/online/courses/human-genetic-variation-introduction/what-is-genetic-variation/what-are-variants-alleles-and-haplotypes/" target="_blank"> here.</LinkAnchor></p>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">What's a phenotype</div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>Find the definition for phenotype<LinkAnchor href="https://www.genome.gov/genetics-glossary/Phenotype" target="_blank"> here.</LinkAnchor></p>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What is a rsID number?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Standing for "Reference SNP cluster ID," the rsID number is used by researchers and databases
                                            to identify a variant, or specific SNP (Single Nucleotide Polymorphism), within a gene. On your
                                            SNiP DNA Report(s), rsID numbers are listed in the far left column, under the gene’s name. </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">SNP vs Mutation: What’s the difference?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>A mutation typically refers to a change in observable traits or characteristics and can be seen in
                                            a single event or person. </p>
                                        <p>A SNP "polymorphism" is observed in more than 1% of the population. They are the most common type of genetic variation.</p>
                                        <p>“Mutation” sounds worse, but essentially, SNPs and mutations describe the same genetic variation.
                                            Both “SNP” and “mutation” refer to a difference in the nucleotides within our DNA.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What are “actionable” genes?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>The genetic expression of SNP-derived physical traits, such as hair or eye color cannot be changed
                                            by diet or lifestyle choices. The actionable SNPs we test for, play essential roles in myriad physiological
                                            functions from detoxification to mood to the effects of aging on skin.  </p>

                                        <p>“However, unlike with hair or eye color, the impact of these SNPs can be mediated by specific nutritional intervention.
                                            The right forms and amounts of certain nutrients, in other words, can proactively support genetic vulnerabilities. Thus, the SNPs we test for are considered “actionable,” because action can be taken to counterbalance
                                            less-than-optimal genetic blueprints. CODE Complex™ personalized nutrition is an easy way to nutritionally “hack”
                                            your genetic blueprint.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What are antioxidants?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Antioxidants are compounds that have a propensity to scavenge free radicals, aiding in the fight against oxidation.
                                            Antioxidants are found naturally in many plants, which is one of the reasons eating fruits and vegetables is
                                            so important, and why we include them in your CODE Complex™.  </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What is oxidation?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>The oxidation that occurs in our bodies is similar to the oxidation that we observe on a daily basis, like the
                                            rusting of iron. Both oxygen and water corrode iron. Iron is transformed into iron oxides during "rusting,
                                            " which weakens the metal because they lack the same strength as iron. Eventually, the entire mass of iron
                                            will disintegrate. The process of oxidation in our bodies is comparable. Our lives routinely include oxidation.
                                            Reactive oxygen species, often known as "free radicals," are produced by the very act of eating and digestion
                                            and attack and harm molecules in our DNA, proteins, lipid membranes, and other tissues.

                                            Both exercise and sun exposure boost the production of free radicals. In essence, our bodies are constantly
                                            attacked and are, if you will, "rusting" away. It is thought that oxidation's cumulative damage is what
                                            causes aging, thus the term, "Free Radical Theory of Aging.”  </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Glossary of terms</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <ul>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Gene" target="_blank">Gene</LinkAnchor> </li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Single-Nucleotide-Polymorphisms" target="_blank">SNP</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/acgt" target="_blank">ACGT</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Allele" target="_blank">Allele</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/genotype" target="_blank"> Genotype sequence:</LinkAnchor></li>
                                            <li>  <LinkAnchor href="https://www.genome.gov/genetics-glossary/Risk" target="_blank"> DNA sequencing</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.biologyonline.com/dictionary/wild-type" target="_blank"> Wild type</LinkAnchor></li>
                                            {/*<li> <LinkAnchor href="https://study.com/academy/lesson/what-is-oxidation-definition-process-examples.html" target="_blank" >Oxidation</LinkAnchor></li>
                                            <li>  <LinkAnchor href="https://www.nccih.nih.gov/health/antioxidants-in-depth" target="_blank">Antioxidant</LinkAnchor></li>
    <li> <LinkAnchor href="https://medlineplus.gov/genetics/understanding/basics/cell/" target="_blank">Cells</LinkAnchor></li>*/}
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Telomere" target="_blank">Telomeres</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.ebi.ac.uk/training/online/courses/human-genetic-variation-
                                            introduction/variant-identification-and-analysis/variant-identifiers/"target="_blank">RS number (rsID)</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/homozygous" target="_blank"> homozygous (HO)</LinkAnchor></li>
                                            <li><LinkAnchor href="https://www.genome.gov/genetics-glossary/heterozygous" target="_blank">Heterozygous (HE)</LinkAnchor></li>
                                            <li><LinkAnchor href="https://www.genome.gov/genetics-glossary/Amino-Acids" target="_blank"> Amino Acid</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Epigenetics" target="_blankk"> Epigenetics</LinkAnchor></li>
                                            <li><LinkAnchor href="https://www.genome.gov/genetics-glossary/Gene-Expression" target="_blank"> Gene expression</LinkAnchor></li>
                                            <li><LinkAnchor href="https://www.genome.gov/genetics-glossary/Risk" target="_blank"> Risk</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Genetic-Information-Nondiscrimination-Act" target="_blank"> Genetic Information Non-Discrimination Act (GINA)</LinkAnchor></li>
                                            <li><LinkAnchor href="https://www.genome.gov/genetics-glossary/Genomic-Variation" target="_blank"> Genomic variation</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Methylation" target="_blank"> Methylation</LinkAnchor></li>
                                            <li><LinkAnchor href="https://www.genome.gov/genetics-glossary/messenger-rna" target="_blank"> Messenger RNA (MRNA)</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Microbiome" target="_blank"> Microbiome</LinkAnchor></li>
                                            <li> <LinkAnchor href="https://www.genome.gov/genetics-glossary/Mutation" target="_blank"> Mutation</LinkAnchor></li>
                                        </ul>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <p><strong>Privacy</strong></p>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Is my genetic information safe?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>SNiP Nutrigenomics seeks to exceed leading privacy and security standards and protects your privacy though accreditations
                                            such as CAP, CLIA and HIPAA* compliance.</p>
                                        <p>*HIPAA, The Health Insurance Portability and Accountability Act of 1996, is a federal law that
                                            prompted the creation of standards to protect patient health information from disclosure without
                                            knowledge or consent.</p>
                                        <p>This means your DNA test results will not be released, shared or sold to any person or
                                            third-party without your permission. </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Do you sell my DNA data or personal information?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No. We do not sell your DNA data or personal information.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Can you delete my data?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>If you would like your data and report deleted, please contact support@snipnutrition.com</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What happens to my DNA swab after it's analyzed?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>After your results are successfully analyzed, your DNA swab is destroyed within 90 days.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <p><strong>General</strong></p>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Will I feel different by taking CODE Complex™?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Many people experience improvements in the way they feel and/or function when taking CODE Complex™ on
                                            a regular basis. However, understand that your personalized formula is “working” for you even
                                            if you don’t feel any different. Many of the SNPs in the DNA panel identify predispositions  in areas that people typically don’t feel, things such as healthy blood pressure, healthy
                                            lipid support, healthy free-radical defense, and so on.The presence of these SNPs indicate predispositions where you may benefit from long-term targeted support.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Should I consult my doctor before using SNiP supplements?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>If you are under the supervision of a health care professional for any reason, are taking any prescription
                                            medication(s), and/or are pregnant or breastfeeding, you should consult with your health care professional
                                            prior to taking CODE Complex™.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Should I stop taking all other supplements?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Your personalized CODE Complex™ formula is foundational nutrition and the only supplement most people will need.
                                            However, if you have known health concerns, or are taking supplements for specific reasons, especially if
                                            recommended or prescribed by a healthcare professional, you should share your CODE Complex™ formula with your
                                            provider to make sure your nutritional support is appropriate for you. Please note the formulas do not contain
                                            every single vitamin or mineral at 100% RDI, so you should check your formula and discuss with your healthcare
                                            provider to determine if you should take additional supplements.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What should I do if I have a medical or allergy
                                            concern about the product or if I am pregnant or nursing?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Anyone who has an allergy, injury, illness, or other medical condition, or who is pregnant or breastfeeding
                                            should always consult with their medical provider prior to taking SNiP products or starting any exercise regimen.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Are SNiP products tested on animals</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Will my DNA test tell me what, if any, nutritional deficiencies I may have?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No.The DNA test only looks for variants (SNPs) in your genes.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Will my CODE Complex™ correct my SNPs?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No. SNPs are part of the normal configuration of these specific genes in your body. You will have these
                                            SNPs on your DNA for life. While nutrition can support your health in targeted areas the SNPs themselves are hard-coded and will
                                            not change.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Are there any possible side effects to taking CODE Complex™?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Your CODE Complex™ is comprised of large quantities of plant matter, primarily fruit and vegetable components,
                                            in addition to USP-grade vitamins and minerals which should not cause adverse reactions in the majority
                                            of users. However, your supplement also includes Inulin. Inulin is a type of soluble fiber found in
                                            many plants and like all fiber, can affect an individual's GI tract and induce gas and bloating,
                                            especially in people who do not have proper fiber consumption. Most people are not only symptom-free within
                                            30 days, they go on to feel better than ever! If you are under medical supervision for any allergy,
                                            disease, taking prescription medications or if you are pregnant or breastfeeding contact your medical
                                            provider before adding any new supplements to your daily regimen.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Are all CODE Complex™ formulas gluten-free? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Yes. All possible combinations of the formulas are gluten-free. </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Are there any limitations on the use of CODE Complex™? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Yes. Some people are sensitive to some of the ingredients in any supplement or certain ingredients may have
                                            prescription drug interactions. We provide you with a complete list of ingredients in your formula. If you
                                            have any concerns, check with your medical provider. These formulas were designed for adults. Pregnancy, breastfeeding,
                                            and medical conditions were not considered in developing these formulas. Pregnant women or women who are breastfeeding,
                                            diabetics, individuals with hypoglycemia, and people with known medical conditions and/or taking prescription drugs
                                            should consult with a licensed physician and/or pharmacist prior to taking any dietary supplements.  </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Is my CODE Complex™ formula really customized to my DNA?  </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Yes, it really is. With the exception of
                                            people with the exact same distribution of SNPs, your formulation is different from everyone else’s.
                                            In fact, there are almost 400 million possible combinations of ingredients in CODE Complex™.  </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Are SNiP products Non-GMO?  </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Yes.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What is the best by date of CODE Complex™?   </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>We store our products in a temperature, humidity, and light-controlled environment to maximize product life.
                                            When you open the product, it is designed to be consumed within the month. SNiP recommends
                                            the product be consumed within this timeframe for best efficacy and/or flavor. Unopened jars
                                            of CODE Complex™ should be kept from excessive heat and light and may be stored for up to twelve months.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Could CODE Complex™ upset my digestive system?  </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Your CODE Complex™ is comprised of large quantities of plant matter, primarily fruit and vegetable components,
                                            in addition to USP-grade vitamins and minerals which should not cause adverse reactions in the majority of users.
                                            Inulin is a type of soluble fiber found in many plants and like all fiber, can affect an individual's
                                            GI tract and induce gas and bloating, especially in people who do not have proper fiber consumption.</p>
                                        <p>If you experience digestive upset, this may be the result of introducing more nutrition in more concentrated
                                            form than your system is used to. You may want to consider ramping up slowly by introducing the product
                                            at a lower rate, say 1 capsule morning and afternoon for a few days, then 2 capsules morning and afternoon
                                            until you have reached the recommended 10 capsules per day.</p>
                                        <p>If you are under medical supervision for any allergy, disease, taking prescription medications,
                                            or if you are pregnant or breastfeeding, contact your medical provider before adding any new supplements
                                            to your daily regimen.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Why does the color of my CODE Complex™ vary from month-to-month? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>This is perfectly normal. The majority of the ingredients found in your formula are natural plant-based
                                            ingredients and there may be color variations from lot to lot due to crop fluctuations from harvest to harvest.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What is the serving size for CODE Complex™?  </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>CODE Complex™ Capsules: 10 per day</p>
                                        <p>CODE Complex™ Powder: 2 scoops per day</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Where do I find a suggested regimen for taking CODE Complex™?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Many people consume CODE Complex™ by taking 5 capsules (or one scoop) during the first half of the day
                                            (typically with a meal) and the second 5 (or second scoop) later in the day (again, with a meal). </p>
                                        <p>However, you may feel free to vary this schedule to meet your personal requirements. </p>
                                        <p>The quantities of ingredients included in 10 capsules or 2 scoops are the amounts validated by science to
                                            be the most efficacious for addressing your combination of SNPs.</p>
                                        <p>While people may take less than the recommended serving per day (10 capsules or 2 scoops) they will be taking
                                            less than the validated quantities that would provide the optimal support for health
                                            in those areas where the SNPs are found.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What is the absorption rate or bioavailability of CODE Complex™?  </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>There is no such thing as a single “percentage” of absorption for a complex product.
                                            It can be calculated for a single ingredient only, and then it varies from a low of 20-25% to high of 80%-90%.
                                            All vitamins, minerals, and components derived from raw foods absorb at different rates. There are minimum
                                            absorption rates for each which are specified by USP (United States Pharmacopeia).
                                            Additionally, many variables outside the product that affect absorption aren’t impacted by either
                                            the product or manufacturer. These include age, gender, overall health, digestive health specifically,
                                            and even what time of day it is, what else has been eaten, and when.</p>
                                        <p>With regards to CODE Complex™, we meet or exceed USP standards. Because our product is always made fresh-for-you,
                                            it will have the highest potency available. We further stimulate absorption through digestive support
                                            by including prebiotic fiber and digestive enzymes in all formulas.</p>
                                        <p>For these reasons we not only support and potentially improve digestion of our product, but all food consumed by that person.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <p><strong>Ingredients</strong></p>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Are any of the ingredients fat soluble vs. water soluble?  </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Water-soluble vitamins are not stored in the body, whereas fat-soluble vitamins can be, leading to
                                            possible toxic conditions in cases of extreme excess quantities. For this reason, SNiP uses as many
                                            water-soluble ingredients as possible and makes sure that all ingredients, including those that are
                                            fat-soluble, are supplied in quantities considered GRAS (Generally Regarded As Safe) by the FDA in
                                            any possible combinations.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Can an ingredient be removed? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>The groupings of ingredients added to a formula to support a specific SP are called "blends." An entire blend
                                            can be removed from a formula if there is any potential for an allergic reaction or a drug metabolism
                                            problem.
                                        </p>
                                        <p>To remove a blend, simply send a request to <a href="mailto:support@snipnutrition.com">support@snipnutrition.com.</a></p>
                                        <p>Our Proprietary Base Blend cannot be removed as it comprises too much volume of the overall product. </p>
                                        <p>Incompatibility with one of the base ingredients means that person should not consume this product.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            {/* <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Why are there “other” ingredients listed at the bottom of my supplements fact sheet?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Not all ingredients in powder form are stable on their own. These other ingredients are called “excipients."
                                            They each serve to stabilize their respective individual ingredients to provide solubility
                                            and to prevent caking for the unique one-at-a-time manufacturing operation which requires micro-dosing
                                            of boosts for individual formulas. All of our excipients are used in the smallest quantities
                                            necessary and are considered safe by the FDA.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion> */}
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How do I find the product label or supplement fact sheet for my CODE Complex™?  </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Because your CODE Complex™ formula is customized to your personal genetic profile, your most current Supplement Facts Panel (SFP) will always be included in each box containing your customized CODE Complex™ formula. You can also find it under "My DNA Reports" in your private account portal. </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Does CODE Complex™ contain artificial sweeteners such as aspartame? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No. CODE Complex™ does not include any artificial colors, flavors or sugars. Other than
                                            excipients that are added to stabilize certain ingredients, there are no additives in CODE Complex™. </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Is my CODE Complex™ vegetarian?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No. The mixed carotenes and vitamin D are both non-vegetarian.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Are there any known allergens in my supplement?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>The FDA requires all food and dietary supplement labels to include an allergen statement for eight major
                                            food allergens: milk, eggs, fish, crustacean shellfish, tree nuts, peanuts, wheat, and soybeans. While
                                            rare food allergies are possible with any edible product, none of these eight food categories is
                                            represented in CODE Complex™.</p>
                                        <p>CODE Complex™ is also gluten-free and non-GMO.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How much caffeine is in my formula?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>There are no detectable levels of caffeine in any formula.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <p><strong>Testing</strong></p>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What does SNiP’s DNA test look at? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>At SNiP, our DNA testing follows a nutritional genomics approach. We analyze how nutrients and genetics
                                            interact and how that interaction impacts the way our body functions. </p>
                                        <p>As we pull and analyze SNPs, we follow nutritional pathways. We’re not just looking at genes that identify
                                            our physical traits. We want to find the genes we can take action on, and support based on your genetic code.
                                            It’s all about examining the nutritional pathways and understanding what we can support with
                                            nutrition and supplementation. </p>
                                        <p>We then offer individualized nutritional supplementation (CODE Complex™), healthy diet and lifestyle
                                            recommendations based on your SNP genetics.</p>
                                    </Typography>
                                </AccordionDetails>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">What other companies do you accept DNA files from? </div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>At this time, we do not accept raw data, DNA reports or files from other companies. The specific,
                                                actionable SNPs we are looking for, and base your customized supplement on, are not all tested for
                                                by other companies. In other words, their tests do not include the data we need to be able to customize your
                                                CODE Complex™ formula. </p>

                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">How long do results take?</div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>Results take approximately 21 days from the date your DNA sample arrives at the lab.</p>

                                            <p>Your customized supplement will be delivered within 7-10 days after ordering. </p>

                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">Forgot to register my kit</div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>You have one year to register your kit. If you forgot to register it, and more than one year has passed,
                                                contact support@snipnutrition.com to ask about a replacement kit. </p>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                        <Typography>
                                            <div className="refunds-provide">Where can I learn more about genetics?</div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <p>Check out our blog at <LinkAnchor href="www.snipnutrition.com/blog" target="_blank"></LinkAnchor>   <LinkAnchor href="https://www.genome.gov" target="_blank">or visit</LinkAnchor> </p>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Is the DNA test a saliva sample or cheek swab?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Cheek swab.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How are genes collected and tested? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>A DNA “sample” is collected by swabbing the inside of your cheeks. (The process is easy and totally painless.)
                                            After collection, the DNA from your skin cells is separated by our specialized laboratory,
                                            and tests are run to determine which genes, if any, have SNPs. </p>
                                        <p>For specific information on how to swab, follow the instruction card included in your DNA kit.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How is DNA collected?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>With a cheek swab (returned to the lab in a pre-paid mailer).</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">After I have taken CODE Complex™ for a while, do I need to be retested?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No. The SNPs we analyze in your DNA panel are hardcoded in your genes and will remain so throughout your life.
                                            Therefore they will not change. So you may wish to have additional genes tested as some point in the
                                            future but you do not need to be retested for these particular SNPs on these genes.</p>
                                        <p>Your CODE Complex™ will continue to support your health and well-being in those areas where you have variants.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How accurate are the SNiP Nutrigenomics genetic tests?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>All of our genetic tests are performed in a laboratory that is CAP accredited and CLIA certified.
                                            These are the highest possible laboratory standards in the United States. The lab runs the test using a
                                            cutting-edge DNA microarray technology and utilizes robotic extraction and processing
                                            and so it is one of the most accurate tests conducted in terms of accuracy and repeatability.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <p> <strong>Laboratory & Manufacturing</strong></p>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Is heat used in the processing of any of SNiP's ingredients?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>The ingredients are not processed through heat. We chose the highest quality and highest standards
                                            in processing as we understand the decrease in bioavailability by heat.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide"> What are our lab’s credentials?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>The lab that runs your DNA test is CLIA Certified (Clinical Laboratory Improvement Amendments),
                                            CAP Accredited (College of American Pathologists) and HIPAA compliant (Health Insurance Portability and
                                            Accountability Act of 1996).</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Is my CODE Complex™ formula tested for purity?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>The state-of-the-art manufacturing facility is cGMP-compliant. All raw material and
                                            finished products are tested for identity, purity and composition.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <p><strong>Ordering, Shipping & Refunds</strong></p>
                            {/*<Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What Are Snip’s Refund Policies?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>If within the first thirty (30) days you are not satisfied with the product you must contact support@snipnutrition.com
                                            to return the unused portion of the product for a full refund of the product purchase amount,
                                            minus return shipping and handling charges incurred.</p>
                                        <p>After thirty (30) days and up to ninety (90) days post purchase, you must contact support@snipnutrition.com to
                                            return the remaining, sellable portion of the product for a full refund minus a 30% percent processing fee
                                            of the original price for all returned product. Any shipping and handling charges incurred when shipping and/or
                                            returning the product will not be refunded. Additionally, anytime an order is refunded,
                                            any affiliate commissions paid will be deducted.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How Long Does It Take For A Refund To Process? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>This can depend on your financial institution as each has its own processing time.
                                            Please allow up to 10 business days.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>*/}
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Refund and Return Policy</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p><strong>Refund Policy</strong></p>
                                        <p>DNA kits, lab fees, data entry, reports and/or other electronically delivered products are non-refundable.</p>
                                        <p><strong>Customized Product Returns</strong></p>
                                        <p>You may request a refund of any amounts charged by contacting customer service at <a href="mailto:support@snipnutrition.com">support@snipnutrition.com</a>. If for any reason you are not completely satisfied with any SNiP
                                            Nutrigenomics products purchased directly from SNiP Nutrigenomics via our website, you may
                                            request a refund within 30 days from the date of delivery for a refund or exchange, a restocking
                                            fee equal to 30% of the original price of the product will be applied. Refunds and exchanges will
                                            be made to the credit card with which the product was purchased. You will need the following to
                                            make your request for refund:
                                            <ul>
                                                <li>
                                                    Proof of Purchase
                                                </li>
                                                <li>
                                                    Unused portion of the product or empty product containers
                                                </li>
                                            </ul>
                                            Your refund includes only the cost of the product. It does not include the costs of shipping and
                                            handling.
                                        </p>
                                        <p><strong>DNA Report Review</strong></p>
                                        <p>Reschedule requests must be made at least 24 hours before your appointment by
                                            emailing <a href="mailto:support@snipnutrition.com">support@snipnutrition.com</a> and providing your name, order number, and date/time of
                                            your appointment. Please do not use the automated Calendly cancel/reschedule link that is
                                            populated in the auto-delivered email. Appointments joined after 10 minutes from the beginning
                                            of the appointed time will be considered no-shows and may not be rescheduled or refunded.</p>
                                        <p><strong>Return Policy</strong></p>
                                        <p>
                                            Before any product is returned to SNiP Nutrigenomics, the customer must contact customer
                                            support to obtain a Return Merchandise Authorization (“RMA”) number. Any package received
                                            without this information on the outside of the box may be refused and may result in a refund not
                                            issuing. SNiP Nutrigenomics does not pay for the cost of return shipping.
                                        </p>
                                        <p><strong>Subscription Cancellation</strong></p>
                                        <p>
                                            Please email support to cancel or modify your Subscription at any time at <a href="mailto:support@snipnutrition.com">support@snipnutrition.com</a>, without penalty. You can also modify or cancel your order at any
                                            time at <a href="www.snipnutrition.com" target="_blank">www.snipnutrition.com</a>. By selecting the "Subscription" option on the website, you are
                                            giving SNiP Nutrigenomics authorization to enroll you in the automatic shipping program. SNiP
                                            Nutrigenomics will ship your products directly to you. You are also authorizing SNiP
                                            Nutrigenomics to charge your credit card for the products you have ordered on a monthly basis
                                            (or other recurring schedule option). You may cancel at any time without obligation and without
                                            penalty by emailing <a href="mailto:support@snipnutrition.com">support@snipnutrition.com</a> or canceling the order on the snipnutrition.com
                                            portal. All Subscription cancellations must be performed or delivered to SNiP Nutrigenomics within
                                            three (3) business days of the next shipment to guarantee cancellation of that shipment.
                                        </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How to ship your kit back to us</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Return your DNA swab in the pre-paid envelope provided in your kit.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            {/* <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How much does shipping cost?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Shipping is included in the price of your home DNA test kit and for your personalized supplement (on subscription) if you live in the U.S.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion> */}
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Can I return DNA test kits together? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No. It is important that you return your cheek-swab in the envelope provided to you with your DNA kit.
                                            The envelope contains a barcode that protects your privacy while still ensuring that your DNA sample
                                            can be analyzed and connected to your report (and customized supplement).</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Do I need to refrigerate the DNA sample? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>No.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Why can’t I test if I live in NY? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>New York is unavailable at this time pursuant to current state law.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">Do you ship outside of the U.S. and Canada?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>We ship DNA test kits and customized supplements to the U.S. and and Canada. If you live in any of the countries
                                            listed below, your customized supplement must be formulated through <a href="https://www.snipnutrition.com/dna-data-entry/" target="_blank">DNA data entry</a> (requires results from
                                            companies such as 23andMe or Ancestry.com). </p>
                                        <p>
                                            <ul>
                                                <li>UK</li>
                                                <li>Australia</li>
                                                <li>Germany</li>
                                                <li>Denmark</li>
                                                <li>Finland</li>
                                                <li>Netherlands</li>
                                                <li>Sweden</li>
                                                <li>Ireland</li>

                                            </ul>
                                        </p>
                                        <p>If you have any questions, or live in a country not listed here and are interested in purchasing DNA-precision
                                            nutrition from SNiP, please message us at <a href="mailto:support@snipnutrition.com">support@snipnutrition.com</a> </p>
                                    </Typography>

                                </AccordionDetails>
                            </Accordion>
                            <p><strong>Privacy</strong></p>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How can I make sure my DNA information is kept private and secure?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Your privacy is our priority. In fact, while your sample is being assessed,
                                            it is only identified by a unique and random barcoded number with no human identifiers,
                                            so it would be impossible for anyone to identify the information of any single individual. But even then,
                                            your information is held in the strictest confidence, in a program that is HIPAA-compliant
                                            (the federal regulations governing the confidentiality of all medical information) and provided only
                                            to you (or your physician, with your permission). The only way anyone else would get your genetic
                                            information from your report(s), is if you share the results directly..</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What happens to my sample after my DNA test is run? </div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>Once your DNA test results are confirmed, your sample is destroyed within 90 days.
                                            Your genetic information is kept in electronic storage with the highest levels of encryption and
                                            is identified only by the random bar code number that only SNiP can associate with your identity
                                            and used only for the purposes of manufacturing and delivering your products to you.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">What type of DNA testing does SNiP use?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>We use <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3841808/" target="_blank">Next Generation  Sequencing</a>(NGS). Our testing is performed in a CLIA (Clinical Laboratory Improvement Act)
                                            certified and CAP (College of American Pathologists) accredited laboratory using highest possible industry
                                            standards. We test using leading-edge DNA microarray technology and robotic extraction and processing.</p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<AddCircleOutlineIcon />} aria-controls="panel1a-content">
                                    <Typography>
                                        <div className="refunds-provide">How accurate is DNA testing by SNiP?</div>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p>We use leading-edge biotechnology to meet or exceed the highest possible industry standards for accuracy.
                                            The clinical-grade testing is performed in a CLIA (Clinical Laboratory Improvement Act)
                                            certified and CAP (College of American Pathologists) accredited laboratory using cutting-edge
                                            DNA microarray technology and robotic extraction and processing. We believe our test
                                            to be one of the most reliable and accurate in the world. </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </>

        </FaqStyle >
    );
}
